export const USE_MOCK_ABHA_OTP = true
export const ABHA_MOCK_OTP = '123456'

export const ABHA_AADHAAR_SEND_OTP_ENDPOINT = '/gi/p/health/abha/aadhaar/send-otp'
export const ABHA_AADHAAR_VERIFY_OTP_ENDPOINT = '/gi/p/health/abha/aadhaar/verify-otp'

export const ABHA_RELATIONSHIP_UPDATE_TIMEOUT_MS = 15000
export const ABHA_RELATIONSHIP_UPDATE_ENDPOINT = '/health/journey/v2/abha/relationships'
export const ABHA_RELATIONSHIP_UPDATE_ERROR = 'Unable to update relationships. Please try again.'
export const ABHA_RELATIONSHIP_PARTIAL_UPDATE_ERROR = 'Some relationships could not be updated. Please try again.'
